import * as yup from "yup";

const changePasswordValidator = yup
  .object({
    password: yup.string().required("Password is required"),
    new_password: yup.string().required("New Password is required"),
    confirm_password: yup.string().required("Confirm Password is required"),
  })
  .required();

export default changePasswordValidator;
